import service from "@irati-tracking/tracker"

const tracking = {}

tracking.startCreateCompanyValue = () => {
  service.trackEvent("admin_start_create_company_value")
}

tracking.startEditCompanyValue = () => {
  service.trackEvent("admin_start_edit_company_value")
}

tracking.createCompanyValue = (companyValue) => {
  const data = {
    companyValueDesc: companyValue.desc,
    companyValueName: companyValue.name,
    companyValueTag: companyValue.tag
  }
  service.trackEvent("admin_create_company_value", data)
}

tracking.editCompanyValue = (companyValue, uuid) => {
  const data = {
    companyValueUuid: uuid,
    companyValueDesc: companyValue.desc,
    companyValueName: companyValue.name,
    companyValueTag: companyValue.tag
  }
  service.trackEvent("admin_edit_company_value", data)
}

tracking.archiveCompanyValue = () => {
  service.trackEvent("admin_archive_company_value")
}

export default tracking
